import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useUserProfileAccess } from '../../auth/helper/useUserProfileAccess';
import { WA_AUDIT_NAV_ITEM, visibleWaNavItems } from './waNavItems';
import { WaCornerLogo, WaFooter, WaTopBar } from './WaChrome';

const WaLayout = () => {
  const location = useLocation(); // Get the current location
  const currentPath = location.pathname; // Get the current path

  // A profile that is inactive - including one auto-provisioned on first sign-in - gets nothing
  // but its own profile page until an administrator activates it.
  const access = useUserProfileAccess();
  const { accountActive, canViewPiiAuditLog, loaded } = access;
  const onMyProfile = currentPath === '/whatsapp/my-profile';
  const locked = loaded && !accountActive;

  return (
    <div className="layout">

      {/* The Primedha Connect logo on its own, in the extreme top left corner of every WhatsApp page - above the side panel, not in it */}
      <WaCornerLogo />

      <div className="main-content">
        <nav className="side-pane wa-side-pane">
          <ul>
            {/* A locked-out profile gets no entries here (its Logout stays in the top bar, so it is not stranded). */}
            {!locked && (
            <>
            {/* Rows alternate between two shades (shade-a / shade-b, see Global.css). */}
            {visibleWaNavItems(access).map((item, index) => (
              <li key={item.path} className={`nav-item ${index % 2 === 0 ? 'shade-a' : 'shade-b'}`}>
                <Link to={item.to} className={currentPath === item.path ? 'active' : ''}>
                  <span className="nav-icon"><FontAwesomeIcon icon={item.icon} /></span>
                  <span className="nav-text">{item.label}</span>
                </Link>
              </li>
            ))}
            {/* Last entry, SYSTEM_ADMIN only: who unmasked or downloaded personal data. The service enforces the same rule. */}
            {canViewPiiAuditLog && (
              <li className="audit-link-item">
                <Link to={WA_AUDIT_NAV_ITEM.to}
                  className={`audit-link ${currentPath === WA_AUDIT_NAV_ITEM.path ? 'active' : ''}`}>
                  <span className="audit-link-icon"><FontAwesomeIcon icon={WA_AUDIT_NAV_ITEM.icon} /></span>
                  <span className="audit-link-text">{WA_AUDIT_NAV_ITEM.label}</span>
                </Link>
              </li>
            )}
            </>
            )}
          </ul>
        </nav>
        <div className="content-pane wa-content">
          <WaTopBar locked={locked} />
          {locked && !onMyProfile ? (
            <div className="page-container">
              <h1>Account Pending Activation</h1>
              <div className="profile-empty">
                Your profile is not active yet, so the rest of the application is unavailable.
                Use <Link to="my-profile">My User Profile</Link> to review your details, and ask an
                administrator to activate your account.
              </div>
            </div>
          ) : (
            <Outlet /> /* This is crucial for rendering child route components */
          )}
          <WaFooter />
        </div>
      </div>
    </div>
  );
};

export default WaLayout;
